import React, { useEffect, useState } from 'react';
import { useT } from '../../../contexts/LocaleContext.jsx';
import '../../../styles/partial/modal/FileDisplayModal.css'; // Import the modal styles

function FileDisplayModal({ open, onClose, title, file}) {
  const t = useT();
  const [fileText, setFileText] = useState('');
  // Set when the document could not be fetched; the message is translated at
  // render so it follows the locale.
  const [loadFailed, setLoadFailed] = useState(false);

  // Only the text document is shown (SHELL-04, ENG-523): a 404, or the SPA's
  // index.html that a missing file falls back to, is a failure too — it used
  // to appear in the <pre> as raw HTML.
  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setLoadFailed(false);
    setFileText('');
    fetch(`/assets/docs/${file}.txt`)
      .then((res) => {
        const type = res.headers?.get?.('content-type') || '';
        if (!res.ok || /html/i.test(type)) throw new Error(`not the document (${res.status} ${type})`);
        return res.text();
      })
      .then((text) => {
        if (cancelled) return;
        if (/^\s*<(!doctype|html)/i.test(text)) throw new Error('not the document (HTML body)');
        setFileText(text);
      })
      .catch(() => {
        if (!cancelled) setLoadFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [open, file]);

  if (!open) return null;

  return (
    <div className="file-modal-overlay" onClick={onClose}>
      <div className="file-modal" onClick={e => e.stopPropagation()}>
        <button className="file-modal-close" onClick={onClose} aria-label={t('common.actions.close')}>&times;</button>
        <h2 className="file-modal-title">{title}</h2>
        <pre className="file-modal-content">{loadFailed ? t('footer.fileModal.loadFailed') : fileText}</pre>
      </div>
    </div>
  );
}

export default FileDisplayModal;